<template>
    <div class="crumbs-container" >
        <div class="crumbs-item" @click="$emit('goTo', 0)">
            <span class="crumbs-text">{{toLocal('generic.home')}}</span>
            <span class="crumbs-separator">
                <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.79592 5.46185L1.18321 9.80869C1.05322 9.93119 0.87693 10 0.693107 10C0.509283 10 0.332989 9.93119 0.203006 9.80869C0.0730234 9.6862 1.36959e-09 9.52007 0 9.34684C-1.36959e-09 9.17361 0.0730234 9.00748 0.203006 8.88499L4.32619 5.00054L0.20416 1.11501C0.139799 1.05436 0.0887446 0.982355 0.0539127 0.90311C0.0190808 0.823865 0.00115298 0.738931 0.00115298 0.653157C0.00115298 0.567384 0.0190808 0.48245 0.0539127 0.403205C0.0887446 0.32396 0.139799 0.251957 0.20416 0.191305C0.268521 0.130654 0.344928 0.0825429 0.42902 0.0497187C0.513111 0.0168945 0.60324 -6.39065e-10 0.69426 0C0.78528 6.39065e-10 0.875409 0.0168945 0.9595 0.0497187C1.04359 0.082543 1.12 0.130654 1.18436 0.191305L5.79707 4.53815C5.8615 4.59879 5.91259 4.67083 5.94741 4.75012C5.98224 4.82942 6.00011 4.91441 6 5.00023C5.99989 5.08604 5.98181 5.17099 5.94679 5.25021C5.91177 5.32943 5.8605 5.40135 5.79592 5.46185Z" fill="#4D4D4D"/>
                </svg>
            </span>
        </div>
        <div 
            class="crumbs-item" 
            v-for="(item, index) in path" 
            :key="index" 
            :class="{'current': index === path.length - 1}" 
            @click="(index != path.length - 1) ? $emit('goTo', item.id) : ''"
        >
             <div class="crumb-wrapper" v-if="(index == (path.length - 1))" v-click-outside-2="finishTitleEdit">
                <span 
                    v-if="!editingTitle" 
                    class="crumbs-text" 
                    @click="type=='home' ? '' : ((index === (path.length - 1)) ? startEdit(index) : '')"
                >
                    {{ item.name }}
                </span>
                <input 
                    ref="titleInput" 
                    v-if="editingTitle"
                    type="text" 
                    v-model="item.name" 
                    maxlength="255"
                    :style="{width: inputWidth+8 + 'px'}"
                    @input="setWidth"
                >
                <span ref="hiddenTitle" class="hidden" v-if="editingTitle">{{item.name}}</span>
            </div>
            <div class="crumb-wrapper" v-else>
                <span 
                    class="crumbs-text" 
                >
                    {{ item.name }}
                </span>
                 <span class="crumbs-separator">
                    <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.79592 5.46185L1.18321 9.80869C1.05322 9.93119 0.87693 10 0.693107 10C0.509283 10 0.332989 9.93119 0.203006 9.80869C0.0730234 9.6862 1.36959e-09 9.52007 0 9.34684C-1.36959e-09 9.17361 0.0730234 9.00748 0.203006 8.88499L4.32619 5.00054L0.20416 1.11501C0.139799 1.05436 0.0887446 0.982355 0.0539127 0.90311C0.0190808 0.823865 0.00115298 0.738931 0.00115298 0.653157C0.00115298 0.567384 0.0190808 0.48245 0.0539127 0.403205C0.0887446 0.32396 0.139799 0.251957 0.20416 0.191305C0.268521 0.130654 0.344928 0.0825429 0.42902 0.0497187C0.513111 0.0168945 0.60324 -6.39065e-10 0.69426 0C0.78528 6.39065e-10 0.875409 0.0168945 0.9595 0.0497187C1.04359 0.082543 1.12 0.130654 1.18436 0.191305L5.79707 4.53815C5.8615 4.59879 5.91259 4.67083 5.94741 4.75012C5.98224 4.82942 6.00011 4.91441 6 5.00023C5.99989 5.08604 5.98181 5.17099 5.94679 5.25021C5.91177 5.32943 5.8605 5.40135 5.79592 5.46185Z" fill="#4D4D4D"/>
                    </svg>
                </span>
            </div>
           
        </div>
    </div>
</template>

<script>
export default {
    props:{
        path: {
            type: Array,
            required: true
        },
        type:{
            type: String,
            default: 'edit'
        }
    },
    data(){
        return{
            editingTitle: false,
            inputWidth: 0,
            pathIndex: null
        }
    },
    computed:{
        titleInputWidth(){
            return this.$refs.hiddenTitle ? this.$refs.hiddenTitle.offsetWidth : '0';
        }
    },
    methods:{
        finishTitleEdit() {
            if(!(this.pathIndex == (this.path.length - 1))) return
            if(this.type == 'home') return 
            if( this.editingTitle)
                this.$emit('updateTitle', this.path[this.path.length - 1].name)
            this.editingTitle = false;
        },
        startEdit(index){
            this.editingTitle = true;
            this.pathIndex = index;
            this.$nextTick(() => {
                this.$refs.titleInput[0].focus();
                this.inputWidth = this.$refs.hiddenTitle[0].offsetWidth;
            });
        },
        setWidth(){
            this.$nextTick(() => {
                this.inputWidth = this.$refs.hiddenTitle[0].offsetWidth;
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.crumbs-container{
    display: flex;
    flex-wrap:wrap;
    gap: 0.35rem;
    width: 85%;
    margin:clamp(32px, 4.4vh, 44px) auto;
}
.crumbs-item{
    display: flex;
    align-items: center;
    gap: 0.35rem;
    color: #B2B2B2;
    cursor: pointer;
    letter-spacing: 0.01rem;
    font-size: clamp(0.8rem, 1.5vw, 1rem);
    &.current{
        color: #000;
        cursor: default;
        .crumbs-text{
            max-width: 100%;
        }
    }
}
.crumbs-text{
    max-width: 14rem;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
input{
    background: transparent;
    border: none;
    font-size: clamp(0.8rem, 1.5vw, 1rem);
    border-bottom: 1px solid #000;
    height: 100%;
    letter-spacing: 0.01rem;
    padding:0;
    font-family: var(--main-site-font);
    &:focus{
        outline: none;
    }
}
.hidden{
    position: absolute;
    z-index: -1;
    opacity: 0;
}
</style>